/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import useDebounce from 'modules/common/components/UseDebounce';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../action';
import * as c from '../constant';

import CmsContext from '../../../../context/CmsContext';
import ApplicationContentSmartCity from './ApplicationContentSmartCity';

const form = {
  keyword: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  module_type: 'RPTAX',
};

const formSmartCity = {
  keyword: '',
  status: '',
};

function ApplicationContainerSmartCity({
  getTransactionListSmartCity,
  transactionListSmartCity,
  transactionListPagerSmartCity,
  isLoadingSmartCity,

  match,
  // isLoading,
  history,
  approveTransaction,
  // showTransaction,
}) {
  const cmsContext = useContext(CmsContext);

  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');


  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(formSmartCity);
  const [filter, setFilter] = useState(formSmartCity);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {
    // getTransactionList();
    getTransactionListSmartCity();
    return () => {
      setModal({ isOpen: false });
    };
  };

  const paramSmartCity = {
    q: formData.keyword,
    sort_by: 'asc',
    status: filter.status,
  }

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      transaction_status: e.value,
    });
    getTransactionListSmartCity({ ...filter, transaction_status: e.value });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getTransactionListSmartCity({ q: formData.keyword });
    } else {
      getTransactionListSmartCity();
    }
  }, [debouncedSearchTerm]);

  const handleApprove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Approve this application?',
      (remarks) => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'FOR PICK-UP',
          },
          () => {
            showTransactionSmartCity(_.get(data, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'PENDING LAB TEST',
          },
          () => {
            showTransactionSmartCity(_.get(data, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };
  
  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => {
          return (
            <GenericListPair
            getData={getTransactionListSmartCity}
            setParams={paramSmartCity}
            setKeyword={handleOnChange}
            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'transaction_status')
            )}
            status={_.get(filter, 'transaction_status') || ''}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            listName="Transaction"
            label="Transaction List"
            renderItem={(item) => {

              return (
                <div className="px-3 py-3">
                  <div className="transaction-list-company">
                    {`${_.get(item, 'attributes.account_name')}`} 
                  </div>
                  <h4 className="mt-1 mb-0 transaction-list-name">
                    {' '}
                    {_.get(item, 'attributes.tdn')}{' '}
                  </h4>
                </div>
              )
            }}
            isLoading={isLoadingSmartCity}
            statusFilter
            selected={params.id}
            data={transactionListSmartCity}
            dataPager={transactionListPagerSmartCity}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => {
              return (
                <React.Fragment>
                  <Switch>
                    <Route
                      path={`${match.path}/:id?`}
                      render={() => {
                        return (
                          <ApplicationContentSmartCity
                            UpdateData={UpdateData}
                            onApprove={handleApprove}
                            onReject={handleReject}
                          />
                        )
                      }}
                    />
                  </Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => {
                      return (
                      !params.business_Id && transactionListSmartCity.length > 0 ? (
                        <Redirect
                          to={`${match.url}/${_.first(transactionListSmartCity)?.id}`}
                        />
                      ) : null
                      )
                    }
                    }
                  />
                </React.Fragment>
              )
            }}
          />
        )}}
      />
    </div>
  );
}

ApplicationContainerSmartCity.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  // isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,  
  // for smart city
  getTransactionListSmartCity: PropTypes.instanceOf(Function).isRequired,
  transactionListSmartCity: PropTypes.instanceOf(Array).isRequired,
  transactionListPagerSmartCity: PropTypes.instanceOf(Object).isRequired,
  isLoadingSmartCity: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  // for Smart City
  transactionListSmartCity: _.get(api, `${c.GET_TRANSACTION_SMART_CITY}.list`) || [],
  transactionListPagerSmartCity: _.get(api, `${c.GET_TRANSACTION_SMART_CITY}.pager`) || {},
  isLoadingSmartCity: api.loading.indexOf(c.GET_TRANSACTION_SMART_CITY) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ApplicationContainerSmartCity);
